"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_SCOPE = exports.USER_CLAIM = exports.ROLES_SCOPE = exports.ROLES_CLAIM = exports.ProfileRoles = exports.PlanungRolesHierarchy = exports.PlanungAdminRoles = exports.PROFILE_SCOPE = exports.PROFILE_CLAIM = exports.OTHER_PROFILES_SCOPE = exports.OTHER_PROFILES_CLAIM = exports.ORGANIZATION_SCOPE = exports.ORGANIZATION_CLAIM = exports.OMNI_ORGANIZATION_SCOPE = exports.OMNI_ORGANIZATION_CLAIM = exports.GroupRolesHierarchy = exports.GroupRoles = exports.GRANTED_APPLICATION_CLAIM = exports.CLOUD_SCOPE = exports.CLOUD_QUOTA_CLAIM = exports.CLOUD_GROUPS_CLAIM = exports.CLAIM_NAMESPACE = exports.CHILD_PROFILES_SCOPE = exports.CHILD_PROFILES_CLAIM = exports.BpRolesHierarchy = exports.BpAdminRoles = exports.ApplicationClientIds = exports.AllApplicationClientIds = exports.AdminRolesHierarchy = exports.AdminRoles = exports.APPLICATION_CLAIM = void 0;
exports.isApplicationClaim = isApplicationClaim;
exports.isChildProfileClaim = isChildProfileClaim;
exports.isChildProfilesClaim = isChildProfilesClaim;
exports.isCloudGroup = isCloudGroup;
exports.isCloudGroupsClaim = isCloudGroupsClaim;
exports.isCloudQuotaClaim = isCloudQuotaClaim;
exports.isOmniOrganizationClaim = isOmniOrganizationClaim;
exports.isOrganizationClaim = isOrganizationClaim;
exports.isOtherProfilesClaim = isOtherProfilesClaim;
exports.isProfileClaim = isProfileClaim;
exports.isRoleClaim = isRoleClaim;
exports.isRolesClaim = isRolesClaim;
exports.isUserClaim = isUserClaim;
exports.roleClaimTargetTypes = void 0;
let AdminRoles = exports.AdminRoles = /*#__PURE__*/function (AdminRoles) {
  AdminRoles["OrganizationAdmin"] = "ADMIN";
  AdminRoles["ShadowAdmin"] = "SHADOW_ADMIN";
  AdminRoles["CollaborationAdmin"] = "COLLABORATION_ADMIN";
  AdminRoles["GroupAdmin"] = "GROUP_ADMIN";
  AdminRoles["ProfileAdmin"] = "PROFILE_ADMIN";
  return AdminRoles;
}({});
let ProfileRoles = exports.ProfileRoles = /*#__PURE__*/function (ProfileRoles) {
  ProfileRoles["Teacher"] = "TEACHER";
  ProfileRoles["Student"] = "STUDENT";
  ProfileRoles["Parent"] = "PARENT";
  ProfileRoles["Other"] = "OTHER";
  return ProfileRoles;
}({});
let GroupRoles = exports.GroupRoles = /*#__PURE__*/function (GroupRoles) {
  GroupRoles["Admin"] = "ADMIN";
  GroupRoles["Editor"] = "EDITOR";
  GroupRoles["Viewer"] = "VIEWER";
  return GroupRoles;
}({});
let BpAdminRoles = exports.BpAdminRoles = /*#__PURE__*/function (BpAdminRoles) {
  BpAdminRoles["Admin"] = "BP_ADMIN";
  BpAdminRoles["ThreemaAdmin"] = "BP_THREEMA_ADMIN";
  BpAdminRoles["CloudAdmin"] = "BP_CLOUD_ADMIN";
  BpAdminRoles["ZoomAdmin"] = "BP_ZOOM_ADMIN";
  return BpAdminRoles;
}({});
let PlanungAdminRoles = exports.PlanungAdminRoles = /*#__PURE__*/function (PlanungAdminRoles) {
  PlanungAdminRoles["Admin"] = "PLANUNG_ADMIN";
  PlanungAdminRoles["StundenAdmin"] = "PLANUNG_STUNDEN_ADMIN";
  PlanungAdminRoles["DeputatAdmin"] = "PLANUNG_DEPUTAT_ADMIN";
  PlanungAdminRoles["VertretungAdmin"] = "PLANUNG_VERTRETUNG_ADMIN";
  return PlanungAdminRoles;
}({});
const ApplicationClientIds = exports.ApplicationClientIds = {
  Planung: "planung-frontend-client",
  Bp: "bp-frontend-client",
  Vpo: "vpo-api-client",
  Admin: "admin-frontend-client",
  BpApp: "bp-app-client",
  Procurat: "procurat-dashboard-client",
  Iphis: "iphis-frontend-client",
  IphisApi: "iphis-api-client",
  IphisVplan: "iphis-vplan-client"
};
const AllApplicationClientIds = exports.AllApplicationClientIds = Object.values(ApplicationClientIds);
const AdminRolesHierarchy = exports.AdminRolesHierarchy = {
  [AdminRoles.OrganizationAdmin]: [AdminRoles.GroupAdmin, AdminRoles.ProfileAdmin, AdminRoles.ShadowAdmin, AdminRoles.CollaborationAdmin, BpAdminRoles.Admin, PlanungAdminRoles.Admin],
  [AdminRoles.GroupAdmin]: [],
  [AdminRoles.ProfileAdmin]: [],
  [AdminRoles.ShadowAdmin]: [],
  [AdminRoles.CollaborationAdmin]: []
};
const GroupRolesHierarchy = exports.GroupRolesHierarchy = {
  [GroupRoles.Admin]: [GroupRoles.Editor, GroupRoles.Viewer],
  [GroupRoles.Editor]: [GroupRoles.Viewer],
  [GroupRoles.Viewer]: []
};
const BpRolesHierarchy = exports.BpRolesHierarchy = {
  [BpAdminRoles.Admin]: [BpAdminRoles.CloudAdmin, BpAdminRoles.ThreemaAdmin, BpAdminRoles.ZoomAdmin],
  [BpAdminRoles.CloudAdmin]: [],
  [BpAdminRoles.ThreemaAdmin]: [],
  [BpAdminRoles.ZoomAdmin]: []
};
const PlanungRolesHierarchy = exports.PlanungRolesHierarchy = {
  [PlanungAdminRoles.Admin]: [PlanungAdminRoles.DeputatAdmin, PlanungAdminRoles.StundenAdmin],
  [PlanungAdminRoles.DeputatAdmin]: [],
  [PlanungAdminRoles.StundenAdmin]: [],
  [PlanungAdminRoles.VertretungAdmin]: []
};
const PROFILE_SCOPE = exports.PROFILE_SCOPE = "profile";
const ROLES_SCOPE = exports.ROLES_SCOPE = "roles";
const USER_SCOPE = exports.USER_SCOPE = "user";
const OTHER_PROFILES_SCOPE = exports.OTHER_PROFILES_SCOPE = "other_profiles";
const CHILD_PROFILES_SCOPE = exports.CHILD_PROFILES_SCOPE = "child_profiles";
const ORGANIZATION_SCOPE = exports.ORGANIZATION_SCOPE = "organization";
const OMNI_ORGANIZATION_SCOPE = exports.OMNI_ORGANIZATION_SCOPE = "omni_organization";
const CLOUD_SCOPE = exports.CLOUD_SCOPE = "cloud";
const CLAIM_NAMESPACE = exports.CLAIM_NAMESPACE = "https://claims.pim.tks.eu";
const PROFILE_CLAIM = exports.PROFILE_CLAIM = `${CLAIM_NAMESPACE}/${PROFILE_SCOPE}`;
const USER_CLAIM = exports.USER_CLAIM = `${CLAIM_NAMESPACE}/${USER_SCOPE}`;
const OTHER_PROFILES_CLAIM = exports.OTHER_PROFILES_CLAIM = `${CLAIM_NAMESPACE}/${OTHER_PROFILES_SCOPE}`;
const CHILD_PROFILES_CLAIM = exports.CHILD_PROFILES_CLAIM = `${CLAIM_NAMESPACE}/${CHILD_PROFILES_SCOPE}`;
const ROLES_CLAIM = exports.ROLES_CLAIM = `${CLAIM_NAMESPACE}/${ROLES_SCOPE}`;
const CLOUD_GROUPS_CLAIM = exports.CLOUD_GROUPS_CLAIM = `${CLAIM_NAMESPACE}/${CLOUD_SCOPE}_groups`;
const CLOUD_QUOTA_CLAIM = exports.CLOUD_QUOTA_CLAIM = `${CLAIM_NAMESPACE}/${CLOUD_SCOPE}_quota`;
const ORGANIZATION_CLAIM = exports.ORGANIZATION_CLAIM = `${CLAIM_NAMESPACE}/${ORGANIZATION_SCOPE}`;
const OMNI_ORGANIZATION_CLAIM = exports.OMNI_ORGANIZATION_CLAIM = `${CLAIM_NAMESPACE}/${OMNI_ORGANIZATION_SCOPE}`;
const APPLICATION_CLAIM = exports.APPLICATION_CLAIM = `${CLAIM_NAMESPACE}/application`;
const GRANTED_APPLICATION_CLAIM = exports.GRANTED_APPLICATION_CLAIM = `${CLAIM_NAMESPACE}/applications_granted`;
const roleClaimTargetTypes = exports.roleClaimTargetTypes = ["Organization", "Group", "Profile", "User"];
function isProfileClaim(o) {
  if (!isPlainOldObject(o)) {
    return false;
  }
  const oo = o;
  return !!oo.uuid && typeof oo.uuid === "string" && isProfileClaimOrganization(oo.organization);
}
function isChildProfileClaim(o) {
  if (!isPlainOldObject(o)) {
    return false;
  }
  const oo = o;
  return !!oo.uuid && typeof oo.uuid === "string" && (oo.canBeImpersonated === undefined || oo.canBeImpersonated === null || typeof oo.canBeImpersonated === "boolean") && isProfileClaimOrganization(oo.organization);
}
function isProfileClaimOrganization(o) {
  if (!isPlainOldObject(o)) {
    return false;
  }
  const oo = o;
  return !!oo.uuid && typeof oo.uuid === "string" && !!oo.name && typeof oo.name === "string";
}
function isUserClaim(o) {
  if (!isPlainOldObject(o)) {
    return false;
  }
  const oo = o;
  return !!oo.uuid && typeof oo.uuid === "string";
}
function isOtherProfilesClaim(o) {
  if (!o || !Array.isArray(o)) {
    return false;
  }
  return !o.some(element => !isProfileClaim(element));
}
function isChildProfilesClaim(o) {
  if (!o || !Array.isArray(o)) {
    return false;
  }
  return !o.some(element => !isChildProfileClaim(element));
}
function isRoleClaim(o) {
  if (!isPlainOldObject(o)) {
    return false;
  }
  const oo = o;
  return !!oo.name && typeof oo.name === "string" && isRoleClaimTarget(oo.target);
}
function isRoleClaimTarget(o) {
  if (!isPlainOldObject(o)) {
    return false;
  }
  const oo = o;
  return !!oo.type && typeof oo.type === "string" && roleClaimTargetTypes.includes(oo.type) && !!oo.uuid && typeof oo.uuid === "string";
}
function isRolesClaim(o) {
  if (!o || !Array.isArray(o)) {
    return false;
  }
  return !o.some(element => !isRoleClaim(element));
}
function isOmniOrganizationClaim(o) {
  if (!o) {
    return false;
  }
  const oo = o;
  return !!oo.uuid && typeof oo.uuid === "string";
}
function isOrganizationClaim(o) {
  return isPlainOldObject(o) && typeof o.uuid === "string" && o.uuid.length > 0 && typeof o.name === "string" && o.name.length > 0 && Array.isArray(o.collaboratesWith) && !o.collaboratesWith.some(el => !isCollaboratesWith(el));
}
function isCloudGroup(g) {
  return isPlainOldObject(g) && !!g.gid && !!g.displayName && typeof g.gid === "string" && g.gid.length > 0 && typeof g.displayName === "string" && g.displayName.length > 0;
}
function isCloudGroupsClaim(g) {
  return Array.isArray(g) && !g.some(el => !isCloudGroup(el));
}
function isCloudQuotaClaim(g) {
  return typeof g === "number";
}
function isApplicationClaim(a) {
  return typeof a === "string";
}
function isCollaboratesWith(o) {
  return isPlainOldObject(o) && typeof o.uuid === "string" && o.uuid.length > 0 && typeof o.name === "string" && o.name.length > 0;
}
function isPlainOldObject(o) {
  return !!o && typeof o === "object" && !Array.isArray(o);
}